export default function Testimonials() {
  const testimonials = [
    {
      name: 'Taís Pinheiro',
      location: 'Sinop - MT',
      role: 'Modelo Internacional',
      videoId: 'fWZeK74x6Us',
      initial: 'T',
    },
    {
      name: 'Beatriz Zachert',
      location: 'Sorriso - MT',
      role: 'Modelo Internacional',
      videoId: 'GEI7zFUsukk',
      initial: 'B',
    },
    {
      name: 'Douglas Malmman',
      location: 'CEO da Mädchen Models',
      role: 'Modelo Internacional',
      videoId: 'Xvk5lA_x5ic',
      initial: 'D',
    },
    {
      name: 'Valentina Marques',
      location: 'Presidente Figueiredo - AM',
      role: 'Atriz',
      videoId: 'zLSADgvoVXI',
      initial: 'V',
    },
  ];

  const handleVideoClick = (videoId: string) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  return (
    <section className="py-16 sm:py-20 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          alt="Background"
          className="w-full h-full object-cover object-top"
          src="https://www.sorriso.fourmodelsseletivas.com.br/static/media/bg-testimonials.jpg"
        />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 px-4">
            <a href="#historias">
              Histórias de{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
                Sucesso
              </span>
            </a>
          </h4>
          <p className="text-base sm:text-lg text-gray-400 max-w-xl mx-auto">
            Assista os depoimentos de quem já passou pelas nossas seletivas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 mb-8 sm:mb-10">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.name}
              className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-yellow-500/20 flex flex-col"
            >
              <div className="relative w-full aspect-video bg-black">
                <div
                  className="absolute inset-0 w-full h-full cursor-pointer group"
                  onClick={() => handleVideoClick(testimonial.videoId)}
                >
                  <img
                    alt={`Depoimento de ${testimonial.name}`}
                    className="w-full h-full object-cover object-top"
                    src={`https://img.youtube.com/vi/${testimonial.videoId}/hqdefault.jpg`}
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                    <div className="w-14 h-14 sm:w-16 sm:h-16 bg-yellow-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-yellow-500/30">
                      <i className="ri-play-fill text-black text-2xl sm:text-3xl ml-1"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-5 sm:p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-base sm:text-lg text-yellow-500"></i>
                  ))}
                </div>

                <div className="flex items-center gap-3 mt-auto">
                  <div className="w-10 h-10 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-black font-bold text-base">{testimonial.initial}</span>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                    <p className="text-gray-500 text-xs">
                      {testimonial.location} • {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-5 text-center">
            <p className="text-2xl sm:text-3xl font-black text-yellow-500 mb-1">+50.000</p>
            <p className="text-gray-400 text-xs sm:text-sm">Participantes em seletivas</p>
          </div>
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-5 text-center">
            <p className="text-2xl sm:text-3xl font-black text-yellow-500 mb-1">+1.000</p>
            <p className="text-gray-400 text-xs sm:text-sm">Talentos descobertos</p>
          </div>
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-5 text-center">
            <p className="text-2xl sm:text-3xl font-black text-yellow-500 mb-1">Brasil</p>
            <p className="text-gray-400 text-xs sm:text-sm">Inteiro atendido</p>
          </div>
        </div>
      </div>
    </section>
  );
}